import Swiper from "swiper";
import { Navigation, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";

export default function swiperPropertyListing() {

    new Swiper(".property-listing__swiper", {    
        modules: [Navigation, Autoplay],

        // Params
        loop: true,
        grabCursor: true,
        speed: 800,
        autoplay: {
            delay: 4000,
            disableOnInteraction: false,
        },
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 40,

        // Navigation
        navigation: {
            prevEl: ".property-listing__swiper ~ .swiper-button-prev",
            nextEl: ".property-listing__swiper ~ .swiper-button-next",
        },

        breakpoints: {
            1200: {
                slidesPerView: 2.5,
            },
            997: {
                slidesPerView: 1.5,
            },
        },
    })
};
